import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { getDefaultHomePath } from '@/constants/modules';
import { userCanAccessAplicativo } from '@/lib/aplicativoZehMotoca';

interface AplicativoRouteProps {
  children: React.ReactNode;
}

/** Admin / gestor / operador com módulo Aplicativo ZehMotoca em `allowedModules`. */
export const AplicativoRoute: React.FC<AplicativoRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuthStore();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
          <p>Carregando…</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!userCanAccessAplicativo(user.role, user.allowedModules)) {
    return <Navigate to={getDefaultHomePath(user)} replace />;
  }

  return <>{children}</>;
};
